<template>
    <main class="main with-sidebar" v-show="visible">
        <div class="container">
            <div class="row center">
                <div class="col-lg-8 col-md-12">
                    <div class="row">
                        <div class="col-lg-4 col-md-6 col-sm-12">
                            <avatar-widget :url="'/v1/customers/' + customer.id + '/image'" v-model="customer.image" :upload="true"></avatar-widget>
                        </div>
                        <div class="col-lg-8 col-md-6 col-sm-12">
                          <ul class="client-list">
                            <li>
                              <h3>{{customer.name }}</h3>
                            </li>
                            <li v-if="customer.phone">
                                <span aria-hidden="true" class="icon icon-phone"></span> <a :href="'tel:' + customer.phone">{{ customer.phone }}</a>
                            </li>
                            <li v-if="customer.email">
                              <span aria-hidden="true" class="icon icon-email"></span> {{ customer.email }}
                            </li>
                            <li v-if="customer.birthday">
                              <span aria-hidden="true" class="icon icon-calendar"></span> {{ customer.birthday | formatDate }}
                            </li>
                            <li v-if="customer.note">
                              <span aria-hidden="true" class="icon icon-list"></span> {{ customer.note }}
                            </li>
                          </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row center">
                <div class="col-lg-8 col-md-12">
                    <div class="customer-info">
                        <br />
                        <customer-appointments :customer="customer"></customer-appointments>
                    </div>
                </div>
            </div>
        </div>
    </main>
</template>
<script>
  import auth from '@/auth'
  import AvatarWidget from '@/components/widgets/AvatarWidget'
  import CustomerAppointments from './CustomerAppointments'
  export default {
    name: 'CustomerPage',
    components: {CustomerAppointments, AvatarWidget},
    data () {
      return {
        visible: false,
        currency: auth.getOrganization().currency.toUpperCase(),
        customer: {}
      }
    },
    created () {
      this.load()
    },
    watch: {
      '$route.params.customer': function (customerId) {
        this.load()
      }
    },
    methods: {
      load: function () {
        this.visible = false
        let customer = this.$route.params.customer
        this.$api.get('/v1/customers/' + customer).then((response) => {
          if (response.data) {
            this.customer = response.data.data
            this.visible = true
          }
        }).catch((error) => {
          console.error(error)
          this.$events.fire('message-open', {
            type: 'error',
            message: this.$t('message.somethingWentWrong')
          })
          this.$router.go(-1)
        })
      },
      back () {
        this.$router.go(-1)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/pages/Organization/Customers/Customer.vue